import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  hasCookieConsent: false
};

// Slice to manage the state of cookie consent
// This helps in checking if cookie consent has been given and programmatically opening the consent modal where needed
export const cookieConsentSlice = createSlice({
  name: "cookieConsent",
  initialState,
  reducers: {
    setHasCookieConsent: (state, action) => {
      state.hasCookieConsent = action.payload;
    }
  }
});

// Export actions and reducer
export const { setHasCookieConsent } = cookieConsentSlice.actions;
